import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { LeadModel } from "../../models/lead.model";
import { analyticsService } from "../../services/firebase-service";
import { RegisterLeadService } from "../../services/register-lead.service";
import { Header } from "../../components/header";

export const ParticiparComunidade = () => {
  const navigate = useNavigate();
  const [btnText, setBtnText] = useState("Quero participar da comunidade");
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    analyticsService.event("page-participar-comunidade");
  }, []);

  const register = async (formData: FormData) => {
    const nome = formData.get("nome") as string;
    const empresa = formData.get("empresa") as string;
    const email = formData.get("email") as string;
    const telefone = formData.get("telefone") as string;
    const service = new RegisterLeadService();
    await service.register(LeadModel.build({ nome, empresa, email, telefone }));
    navigate({
      pathname: "/participar-comunidade/em-breve",
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setEnabled(false);
    setBtnText("Salvando seus dados. Aguarde...");
    const formData = new FormData(e.currentTarget);
    await register(formData);
  };

  return (
    <main className="container">
      <Header />
      <div className="header">
        <h2 className="h5 my-4">
          Tenha acesso ao conhecimento que falta
          <br /> para sua empresa dar o próximo salto.
        </h2>
      </div>

      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <div className="box">
            <form onSubmit={handleSubmit} method="post">
              <div className="mb-3">
                <label htmlFor="nome" className="form-label">
                  Nome Completo
                </label>
                <input type="text" className="form-control" id="nome" name="nome" placeholder="Insira seu nome e sobrenome" required />
              </div>
              <div className="mb-3">
                <label htmlFor="empresa" className="form-label">
                  Nome da sua Empresa
                </label>
                <input type="text" className="form-control" id="empresa" name="empresa" placeholder="Insira o nome da sua empresa" required />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  E-mail profissional
                </label>
                <input type="email" className="form-control" id="email" name="email" placeholder="Insira seu melhor e-mail" required />
              </div>

              <div className="mb-3">
                <label htmlFor="telefone" className="form-label">
                  DDD + Número
                </label>
                <input type="tel" className="form-control" id="telefone" name="telefone" placeholder="Insira seu Whatsapp" required />
              </div>
              <div>
                <p>🔒 Seus dados serão usados apenas para comunicação sobre a comunidade.</p>
              </div>
              <div>
                <p>
                  👉 Ao continuar o cadastro você aceita nossa{" "}
                  <Link target="_blank" to="/politica-de-privacidade" className="link-secondary">
                    <strong>política de privacidade</strong>
                  </Link>
                  .
                </p>
              </div>
              <div className="d-grid mt-4 mb-3">
                <button type="submit" className="btn btn-primary p-2" disabled={!enabled}>
                  {btnText}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};
